// src/pages/Enseignants/ListingAdherents/components/utils.js

export const seasonNeighbors = (s) => {
  const m = /^(\d{4})\s*-\s*(\d{4})$/.exec(String(s) || "");
  if (!m) return { prev: s, next: s };
  const a = parseInt(m[1], 10);
  const b = parseInt(m[2], 10);
  return { prev: `${a - 1}-${b - 1}`, next: `${a + 1}-${b + 1}` };
};

export const getDefaultPhoto = (genre) =>
  genre === "Masculin" ? "/img/judoka_avatar.png" : "/img/judokate_avatar.png";

export const statusColor = (statut) => {
  switch (statut) {
    case "Licencié":
      return "bg-green-300 text-slate-900";
    case "Licencié Hors Club":
      return "bg-green-200 text-slate-900";
    case "Inscrit":
      return "bg-yellow-300 text-slate-900";
    case "Cours d'essai":
      return "bg-red-300 text-slate-900";
    case "Licencié - Arrêt":
      return "bg-slate-300 text-slate-900";
    case "Ancien Licencié et Arrêt":
      return "bg-slate-300 text-slate-900";
    case "Ancien Licencié":
      return "bg-slate-400 text-slate-900";
    default:
      return "bg-slate-200 text-slate-900";
  }
};

// Récupère des emails probables en gérant différents schémas de champs
export const extractEmailsFromAdherent = (a) => {
  const CANDIDATES = [
    "email", "mail",
    "email_parent", "email_responsable",
    "mail_parent", "mail_responsable",
    "email_pere", "email_mere",
    "mail_pere", "mail_mere",
  ];
  const out = new Set();
  CANDIDATES.forEach((k) => {
    const v = a?.[k];
    if (!v) return;
    // gère valeur simple ou liste séparée par , ; /
    String(v)
      .split(/[;,/ ]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((e) => {
        // filtre basique d'email
        if (/.+@.+\..+/.test(e)) out.add(e);
      });
  });
  return Array.from(out);
};

// Tri
const ageOf = (a) => {
  const d = a?.date_naissance ? new Date(a.date_naissance) : null;
  if (!d) return Number.POSITIVE_INFINITY;
  const now = new Date();
  let A = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) A--;
  return A;
};

export const sorters = {
  alpha: (A, B) => String(A?.nom || "").localeCompare(String(B?.nom || ""), "fr"),
  "age-asc": (A, B) => ageOf(A) - ageOf(B),
  "age-desc": (A, B) => ageOf(B) - ageOf(A),
  statut: (A, B) => String(A?.statut_inscription || "").localeCompare(String(B?.statut_inscription || ""), "fr"),
};
